 export default {
    ParlamentaresGovernantes: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "parlamentares-e-governantes"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ParlamentaresGovernantes.js
// module id = FvHK
// module chunks = 13